import { GroupPlanType } from '../plan';
import { BillingAddress, PaymentMethod } from '../billing';
import { InvoiceDetailStatus } from '../billing/invoice';

export interface GetInvoiceDetailResponse {
  groupId: string;
  paymentMethod: PaymentMethod;
  paymentInfo: {
    paymentInvoiceId: string; // in_1QnV48IKbJfICCQdQk4ESUvL
    paymentTaxId: null | string;
    avalaraDocCode: null | string;
    paymentGatewayType: PaymentMethod;
    last4CardNo: string; // '0000';
  };
  totalAmount: number;
  creditAmount: number;
  cardAmount: number;
  taxAmount: number;
  backOrderInfo: GetInvoiceDetailBackOrderInfo;
  invoiceId: string; // 5E03E5F93A0007
  registeredDate: string; //  2025-02-01T01:00:08.27,
  planType: GroupPlanType;
  status: InvoiceDetailStatus;
  billingAddress: BillingAddress;
  groupInvoiceItems: GetInvoiceDetailItem[];
  group: {
    name: string;
    adminName: string;
    adminEmail: string;
  };
  amount: GetInvoiceDetailPricingAmount;
  detail: GetInvoiceDetailDateInfo;
}

export interface GetInvoiceDetailPricingAmount {
  subTotal: number; //40;
  tax: number; // 3.55;
  total: number; // 43.55;
}

export interface GetInvoiceDetailDateInfo {
  succeedDate: null | string;
  refundDate: null | string;
  failCount: number;
}

export enum GetInvoiceDetailItemType {
  FIRST_SUBSCRIPTION = 1,
  RENEW_SUBSCRIPTION = 2,
  CARRY_OVER_BALANCE = 3,
  DOWNGRADE_SUBSCRIPTION = 4,
  REFUND = 5,
}

export interface GetInvoiceDetailItem {
  id: string; // 'd2f07cda-8871-4aa2-beec-47e1ac9b81e2';
  type: GetInvoiceDetailItemType;
  quantity: number;
  amount: number;
  // status: PaymentStatus; // TODO: legacy payment 타입이므로 추후 테드께서 주실 타입으로 교체해야한다.
  startDate: string;
  endDate: string | null;
  unitPrice: number;
}

export interface GetInvoiceDetailBackOrderInfo {
  registeredAt: string;
  subscriptionTerm: {
    startDate: string;
    endDate: string;
  };
  currentCredit: number;
}
